import EmblaCarousel from 'embla-carousel';
const instagramCarousel = () => {
    const selectors = {
        instagramCarousel: '[data-instagram-carousel]',
        fourSixtyCarousel: '[data-foursixty-carousel]',
        instagramCarouselViewport: '[data-instagram-carousel-viewport]',
        instagramCarouselContainer: '[data-instagram-carousel-container]',
        instagramCarouselPrev: '[data-instagram-carousel-prev]',
        instagramCarouselNext: '[data-instagram-carousel-next]',
    };
    const instagramCarousels = document.querySelectorAll(selectors.instagramCarousel);
    instagramCarousels.forEach((carousel) => {
        const fourSixtyCarousel = carousel.querySelector(selectors.fourSixtyCarousel);
        const viewportNode = carousel.querySelector(selectors.instagramCarouselViewport);
        const containerNode = carousel.querySelector(selectors.instagramCarouselContainer);
        const prevButtonNode = carousel.querySelector(selectors.instagramCarouselPrev);
        const nextButtonNode = carousel.querySelector(selectors.instagramCarouselNext);
        const items = fourSixtyCarousel.querySelectorAll('.fs-timeline-entry');
        items.forEach((item) => {
            containerNode.appendChild(item);
        });
        const observerconfig = { childList: true, subtree: true };
        const observerCallback = () => {
            const items = carousel.querySelectorAll('.fs-timeline-entry');
            items.forEach((item) => {
                containerNode.appendChild(item);
            });
        };
        const observer = new MutationObserver(observerCallback);
        observer.observe(fourSixtyCarousel, observerconfig);
        const options = {
            loop: true,
            align: 'start',
        };
        const embla = EmblaCarousel(viewportNode, options);
        prevButtonNode.addEventListener('click', () => embla.scrollPrev(), false);
        nextButtonNode.addEventListener('click', () => embla.scrollNext(), false);
    });
};
export { instagramCarousel };
